export default function sanitizeHtml(description:string) {
  var tempDiv = document.createElement('div');
  
  // Set the innerHTML of the div to the description
  tempDiv.innerHTML = description;

  // Extract the text content from the div
  var sanitizeText = tempDiv.textContent || "";

  tempDiv.remove();
  return sanitizeText
  // Clean up by removing the temporary div from the document
}
